<template>
  <div class="block-period basic-block">
    <h1>開催期間</h1>
    <p class="period" v-html="period"></p>
  </div>
</template>

<script>
import { mapState } from 'vuex';
export default {
  name: 'BlockPeriod',
  computed: {
    ...mapState({
      isPc: state => state.uiState.isPc,
    }),
    period(){
      return this.isPc ? '2021年10月15日（金）00：00 ～12月31日（金）23：59' : '2021年10月15日（金）00：00<br>～12月31日（金）23：59'
    }
  }
}
</script>

<style scoped lang="scss">
.block-period {
  padding: 40px 20px 0;
  .period {
    text-align: center;
  }
}
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/lp/campaign/LineCampaign202110/blocks/BlockPeriod.vue